import { IonButton } from '@ionic/react';
import styled from 'styled-components';
import { AllieDefaultColors } from '../../../common/color.types';
import { AllieButtonSize } from '../Button';
import { AllieLinkProps } from './Link.types';

const textColor = {
  active: 90,
  hover: 80,
  loading: 70,
  focus: 70,
  initial: 60,
  disabled: 40,
};

type InternalButtonState = 'initial' | 'active' | 'hover' | 'focus';

interface AllieLinkParams {
  disabled: boolean;
  color: AllieDefaultColors;
  size: AllieButtonSize;
}

const defaults: AllieLinkParams = {
  size: 'normal',
  disabled: false,
  color: 'primary',
};

const getColor = (
  state: InternalButtonState,
  disabled = defaults.disabled,
  color = defaults.color
) => {
  if (disabled) return `${color}-${textColor.disabled}`;

  return `${color}-${textColor[state]}`;
};

export const StyledLink: typeof IonButton = styled(IonButton)<AllieLinkProps>`
  --background: transparent;
  --background-activated: transparent;
  --background-hover: transparent;
  --background-focused: var(--allie-color-primary_60);
  --background-focused-opacity: 1;
  --color: var(
    --allie-color-${(props: AllieLinkProps) => getColor('initial', props.disabled, props.color)}
  );
  --color-activated: var(--allie-color-${getColor('active')});
  --color-hover: var(--allie-color-${getColor('hover')});
  --color-focused: var(--allie-color-${getColor('focus')});
  --box-shadow: none;
  --border-style: none;
  --border-radius: 4px;
  text-transform: none;
  --padding-top: 5px;
  --padding-bottom: 5px;
  --padding-start: 15px;
  --padding-end: 15px;
  height: fit-content;
`;
